const BASE_COLORS = [
  '#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231',
  '#911eb4', '#42d4f4', '#f032e6', '#bfef45', '#fabed4',
  '#469990', '#dcbeff', '#9a6324', '#fffac8', '#800000',
  '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080',
];

export function getCategoricalColor(index) {
  return BASE_COLORS[((index % BASE_COLORS.length) + BASE_COLORS.length) % BASE_COLORS.length];
}

export function buildColorMap(keys, colorFunction = getCategoricalColor) {
  const map = {};
  keys.forEach((key, i) => {
    map[key] = colorFunction(i);
  });
  return map;
}

export function hexToRgba(hex, alpha = 1) {
  const match = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
  if (!match) return hex;
  const [, r, g, b] = match;
  return `rgba(${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}, ${alpha})`;
}

const CHILEAN_LITHOLOGY_COLORS = {
  Gravel: '#d4a574',
  Sand: '#f0d9b5',
  Silt: '#c2b280',
  Clay: '#b8a088',
  Conglomerate: '#b5946e',
  Breccia: '#8c7a6b',
  Sandstone: '#d4b868',
  Siltstone: '#b8a060',
  Mudstone: '#988060',
  Shale: '#786850',
  Limestone: '#b8b8a0',
  Dolomite: '#a8b090',
  Chert: '#d0d0c0',
  Coal: '#303030',
  Granite: '#e0c8a0',
  Granodiorite: '#d0b890',
  Diorite: '#b8a080',
  Gabbro: '#686868',
  Rhyolite: '#e8d8b8',
  Dacite: '#d0c0a0',
  Andesite: '#b8a890',
  Basalt: '#484848',
  Porphyry: '#d4b060',
  'Porphyry Copper': '#c87830',
  Skarn: '#90a878',
  Hornfels: '#887858',
  Quartzite: '#d8d0c0',
  Schist: '#908070',
  Gneiss: '#887060',
  Amphibolite: '#607060',
  Serpentinite: '#609070',
  'Iron Oxide': '#8b2020',
  Gossan: '#8b4513',
  Oxide: '#c87840',
  Supergene: '#a08050',
  'Primary Sulphide': '#405080',
  Mixed: '#a08860',
  Overburden: '#d4c8a0',
  Waste: '#b0a890',
};

export function buildCategoricalColorMap(geologyHoles, colors, variable) {
  const colorOverrides = {};
  if (colors) {
    try {
      const parsed = typeof colors === 'string' ? JSON.parse(colors) : colors;
      if (parsed && typeof parsed === 'object') {
        for (const [key, value] of Object.entries(parsed)) {
          colorOverrides[key.toLowerCase().trim()] = value;
        }
      }
    } catch (e) {
      // ignore unparseable colors
    }
  }
  const categories = new Set();
  const holes = geologyHoles || [];
  for (const hole of holes) {
    const points = hole?.points || [];
    for (const point of points) {
      const value = variable ? point?.[variable] : point?.geology_code;
      if (value != null && String(value).trim() !== '') {
        categories.add(String(value).trim());
      }
    }
  }
  const sorted = [...categories].sort();
  const map = {};
  let idx = 0;
  for (const cat of sorted) {
    const lower = cat.toLowerCase();
    if (colorOverrides[lower]) {
      map[cat] = colorOverrides[lower];
    } else if (CHILEAN_LITHOLOGY_COLORS[cat] || CHILEAN_LITHOLOGY_COLORS[lower]) {
      map[cat] = CHILEAN_LITHOLOGY_COLORS[cat] || CHILEAN_LITHOLOGY_COLORS[lower];
    } else {
      map[cat] = getCategoricalColor(idx);
    }
    idx += 1;
  }
  return map;
}

export function colorForCategory(colorMap, category, fallback) {
  if (!category) return fallback || '#808080';
  return colorMap?.[category] || fallback || getCategoricalColor(0);
}
